export const RadioButtonSelected = () => {
  return (
    <svg
      className="svg-icon me-1"
      style={{
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        paddingBottom: '2px',
        fontSize: '20px'
      }}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M196.571136 513.855488c0 174.10048 141.135872 315.236352 315.236352 315.236352 174.10048 0 315.236352-141.135872 315.236352-315.236352 0-174.102528-141.135872-315.236352-315.236352-315.236352C337.707008 198.619136 196.571136 339.755008 196.571136 513.855488L196.571136 513.855488zM511.807488 45.056C252.893184 45.056 43.008 254.941184 43.008 513.855488c0 258.90816 209.885184 468.799488 468.799488 468.799488 258.90816 0 468.799488-209.891328 468.799488-468.799488C980.609024 254.941184 770.715648 45.056 511.807488 45.056L511.807488 45.056zM511.807488 929.792c-229.71392 0-415.936512-186.222592-415.936512-415.936512 0-229.71392 186.222592-415.936512 415.936512-415.936512S927.744 284.141568 927.744 513.855488C927.744 743.569408 741.521408 929.792 511.807488 929.792L511.807488 929.792zM511.807488 929.792" />
    </svg>
  )
}

export const RadioButtonUnselected = () => {
  return (
    <svg
      className="svg-icon me-1"
      style={{
        width: '1em',
        height: '1em',
        verticalAlign: 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        paddingBottom: '2px',
        fontSize: '20px'
      }}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg">
      <path d="M512 938.752C747.648 938.752 938.666667 747.690667 938.666667 512.042667c0-235.690667-191.061333-426.752-426.709334-426.752-235.690667 0-426.752 191.061333-426.752 426.752 0 235.648 191.061333 426.709333 426.752 426.709333z m0-64A362.752 362.752 0 1 1 512 149.333333a362.752 362.752 0 0 1 0 725.461334z" />
    </svg>
  )
}
